import { motion } from "framer-motion";
import { Clock, MessageCircle, Instagram } from "lucide-react";

const INFO = [
  { icon: Clock, label: "Horários", value: "Seg a Sex: após as 18h | Sáb e Dom: 8h às 18h", id: "hours" },
  { icon: MessageCircle, label: "WhatsApp", value: "+55 (43) 98493-8085", id: "whatsapp", href: "https://api.whatsapp.com/send?phone=5543984938085" },
  { icon: Instagram, label: "Instagram", value: "@_dutattoo", id: "instagram", href: "https://www.instagram.com/_dutattoo" },
];

export const Contact = () => (
  <section id="contato" className="py-24 sm:py-32" data-testid="contact-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }} className="mb-14">
        <p className="font-mono-dt text-xs uppercase tracking-[0.35em] text-[#e03131] mb-4">O Estúdio</p>
        <h2 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-4xl lg:text-5xl" data-testid="contact-title">
          Visite o <span className="text-outline">território</span>
        </h2>
      </motion.div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <motion.div initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="relative rounded-lg border border-[#27272a]/70 overflow-hidden min-h-[380px] bg-[#0d0d10]" data-testid="contact-map">
          <div className="absolute inset-0 opacity-[0.13]"
            style={{ backgroundImage: "linear-gradient(#e2d9cc 1px, transparent 1px), linear-gradient(90deg, #e2d9cc 1px, transparent 1px)", backgroundSize: "44px 44px" }} />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_55%_45%,rgba(224,49,49,0.14),transparent_55%)]" />
          <div className="absolute left-[52%] top-[42%] -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
            <span className="relative flex h-5 w-5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#e03131] opacity-60" />
              <span className="relative inline-flex rounded-full h-5 w-5 bg-[#e03131] border-2 border-[#09090b]" />
            </span>
            <span className="mt-3 font-mono-dt text-[10px] uppercase tracking-[0.25em] bg-[#09090b]/90 border border-[#27272a] rounded-full px-4 py-2 text-[#e2d9cc]">
              Dudu Tattoo
            </span>
          </div>
          <div className="absolute bottom-5 left-5 right-5 flex flex-wrap gap-3">
            <span className="flex items-center gap-2 font-mono-dt text-[10px] uppercase tracking-[0.2em] text-zinc-400 bg-[#09090b]/90 border border-[#27272a] rounded-full px-4 py-2">
              <Clock size={12} className="text-[#e03131]" /> Atendimento com hora marcada
            </span>
            <span className="flex items-center gap-2 font-mono-dt text-[10px] uppercase tracking-[0.2em] text-zinc-400 bg-[#09090b]/90 border border-[#27272a] rounded-full px-4 py-2">
              <MessageCircle size={12} className="text-[#e03131]" /> Agende pelo WhatsApp
            </span>
          </div>
        </motion.div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {INFO.map((item, i) => {
            const Icon = item.icon;
            const inner = (
              <>
                <Icon size={20} className="text-[#e03131]" />
                <p className="font-mono-dt text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-4">{item.label}</p>
                <p className="text-sm text-[#e2d9cc] mt-2 leading-relaxed">{item.value}</p>
              </>
            );
            const cls = "rounded-lg border border-[#27272a]/70 bg-[#121215] p-6 hover:border-[#e03131]/50 transition-colors duration-500 block";
            return (
              <motion.div key={item.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.5, delay: i * 0.08 }}>
                {item.href
                  ? <a href={item.href} target="_blank" rel="noreferrer" className={cls} data-testid={`contact-${item.id}`}>{inner}</a>
                  : <div className={cls} data-testid={`contact-${item.id}`}>{inner}</div>}
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
